import * as React from 'react'
import { inject } from 'mobx-react'
import { observer } from 'mobx-react'

@inject('localizationStore')

@observer
export default class ConfirmEmailSuccessPage extends React.Component<any> {
    constructor(props: any) {
        super(props)
    }

    render() {
        let ls = this.props.localizationStore!

        return (
            <div>
                <p className="staticInfo">{ls.t!('ConfirmEmailFailPage')}</p>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/Pages/Account/ConfirmEmailFailPage.tsx